(function() {
var root = document.getElementById('comfort-airflex-tshirts');
if (!root) return;
var cafxUserMoved=false;
['wheel','touchstart','pointerdown','keydown'].forEach(function(n){window.addEventListener(n,function(){cafxUserMoved=true;},{once:true,passive:true});});
if(!window.location.hash&&'scrollRestoration' in history){try{history.scrollRestoration='manual';}catch(e){}}
function cafxStopLoadJump(){if(window.location.hash||cafxUserMoved)return;var y=window.pageYOffset||document.documentElement.scrollTop||0;var rb=root.getBoundingClientRect().bottom+y;if(y>rb-80)window.scrollTo({top:0,behavior:'auto'});}
requestAnimationFrame(cafxStopLoadJump);
window.addEventListener('load',function(){setTimeout(cafxStopLoadJump,0);setTimeout(cafxStopLoadJump,250);setTimeout(cafxStopLoadJump,900);},{once:true});
var colorsSec = root.querySelector('#cafx-colors');
var swatchesSec = root.querySelector('[data-cafx-swatches]');
var mobileColorHead = root.querySelector('[data-cafx-mobile-color-head]');
function getScrollOffset() {
var header = document.querySelector('.shopify-section-header-sticky, .section-header.shopify-section-header-sticky, sticky-header, header[style*="fixed"], header[style*="sticky"]');
var headerHeight = header && window.matchMedia('(max-width: 720px)').matches ? Math.min(header.getBoundingClientRect().height || 0, 90) : 0;
return headerHeight + 42;
}
function gotoColors() {
var isMobile = window.matchMedia('(max-width: 720px)').matches;
var target = isMobile ? (mobileColorHead || swatchesSec || colorsSec) : (colorsSec || swatchesSec);
if (!target) return;
window.scrollTo({
top: target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset(),
behavior: 'smooth'
});
}
root.querySelectorAll('[data-cafx-goto-colors]').forEach(function(el) {
el.addEventListener('click', gotoColors);
el.addEventListener('keydown', function(e) {
if (e.key === 'Enter' || e.key === ' ') {
e.preventDefault();
gotoColors();
}
});
});
function cafxInitCarousel(car) {

if (!car) return null;

var viewport = car.querySelector('[data-cafx-product-viewport]');
var track = car.querySelector('[data-cafx-product-track]');
var prev = car.querySelector('[data-cafx-product-prev]');
var next = car.querySelector('[data-cafx-product-next]');
if (!viewport || !track) return null;
var slides = [].slice.call(track.children);
if (!slides.length) return null;
var snapPoints = [];
var activePointIndex = 0;
var scrollTimer = null;
var animationTimer = null;
var resizeTimer = null;
var isProgrammatic = false;
var lastKnownViewportWidth = 0;
function clampLeft(left) {
var max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
return Math.max(0, Math.min(left, max));
}
function preferredLeft(slide) {
var snap = '';
try { snap = window.getComputedStyle(slide).scrollSnapAlign || ''; } catch (e) {}
if (snap.indexOf('center') > -1) {
return clampLeft(slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2);
}
return clampLeft(slide.offsetLeft);
}
function samePoint(a, b) {
return Math.abs(a - b) < 2;
}
function buildSnapPoints(keepActivePoint) {
var previousActivePoint = activePointIndex;
var max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
snapPoints = [];
slides.forEach(function(slide, idx) {
var left = preferredLeft(slide);
var duplicate = snapPoints.some(function(point) {
return samePoint(point.left, left);
});
if (!duplicate) {
snapPoints.push({ left: left, slideIndex: idx });
}
});
if (max > 2 && !snapPoints.some(function(point) { return samePoint(point.left, max); })) {
snapPoints.push({ left: max, slideIndex: slides.length - 1 });
}
snapPoints.sort(function(a, b) { return a.left - b.left; });
if (!snapPoints.length) {
snapPoints.push({ left: 0, slideIndex: 0 });
}
if (keepActivePoint && snapPoints[previousActivePoint]) {
activePointIndex = previousActivePoint;
} else {
activePointIndex = getNearestPointIndex();
}
lastKnownViewportWidth = viewport.clientWidth;
}
function getNearestPointIndex() {
if (!snapPoints.length) return 0;
var currentLeft = viewport.scrollLeft;
var bestIndex = 0;
var bestDistance = Infinity;
snapPoints.forEach(function(point, idx) {
var distance = Math.abs(point.left - currentLeft);
if (distance < bestDistance) {
bestDistance = distance;
bestIndex = idx;
}
});
return bestIndex;
}
function finishProgrammatic(targetIndex) {
window.clearTimeout(animationTimer);
activePointIndex = typeof targetIndex === 'number' ? targetIndex : getNearestPointIndex();
isProgrammatic = false;
}
function goToPoint(idx, instant) {
if (!snapPoints.length) buildSnapPoints(false);
if (snapPoints.length <= 1) return;
var isLoopForward = idx >= snapPoints.length;
var isLoopBackward = idx < 0;
var targetIndex = isLoopForward ? 0 : isLoopBackward ? snapPoints.length - 1 : idx;
var point = snapPoints[targetIndex];
if (!point) return;
window.clearTimeout(animationTimer);
isProgrammatic = true;
activePointIndex = targetIndex;
var behavior = instant || isLoopForward || isLoopBackward ? 'auto' : 'smooth';
try {
viewport.scrollTo({ left: point.left, behavior: behavior });
} catch (e) {
viewport.scrollLeft = point.left;
}
if (behavior === 'auto') {
requestAnimationFrame(function() { finishProgrammatic(targetIndex); });
} else {
animationTimer = window.setTimeout(function() { finishProgrammatic(targetIndex); }, 520);
}
}
function moveCarousel(dir) {
buildSnapPoints(isProgrammatic);
if (snapPoints.length <= 1) return;
if (!isProgrammatic) {
activePointIndex = getNearestPointIndex();
}
goToPoint(activePointIndex + dir, false);
}
function normaliseAfterResize() {
buildSnapPoints(false);
var point = snapPoints[activePointIndex] || snapPoints[getNearestPointIndex()] || snapPoints[0];
if (!point) return;
try {
viewport.scrollTo({ left: point.left, behavior: 'auto' });
} catch (e) {
viewport.scrollLeft = point.left;
}
finishProgrammatic(activePointIndex);
}
buildSnapPoints(false);
if (prev) {
prev.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
moveCarousel(-1);
});
}
if (next) {
next.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
moveCarousel(1);
});
}
viewport.addEventListener('scroll', function() {
window.clearTimeout(scrollTimer);
scrollTimer = window.setTimeout(function() {
if (!isProgrammatic) {
activePointIndex = getNearestPointIndex();
}
}, 80);
}, { passive: true });
window.addEventListener('resize', function() {
window.clearTimeout(resizeTimer);
resizeTimer = window.setTimeout(function() {
if (Math.abs((viewport.clientWidth || 0) - lastKnownViewportWidth) > 1) {
normaliseAfterResize();
} else {
buildSnapPoints(false);
}
}, 140);
});
slides.forEach(function(slide) {
slide.querySelectorAll('img').forEach(function(img) {
if (!img.complete) {
img.addEventListener('load', function() {
window.clearTimeout(resizeTimer);
resizeTimer = window.setTimeout(function() { buildSnapPoints(false); }, 80);
}, { once: true });
}
});
});

return {
refresh: function() {
requestAnimationFrame(function() {
window.clearTimeout(animationTimer);
window.clearTimeout(resizeTimer);
buildSnapPoints(false);
var first = snapPoints[0] ? snapPoints[0].left : 0;
try {
viewport.scrollTo({ left: first, behavior: 'auto' });
} catch (e) {
viewport.scrollLeft = first;
}
activePointIndex = 0;
isProgrammatic = false;
});
}
};

}

function cafxInitColors(scope) {

if (!scope) return null;
var sw = [].slice.call(scope.querySelectorAll('[data-cafx-swatch]'));
var panels = [].slice.call(scope.querySelectorAll('[data-cafx-panel]'));
var colorPrev = [].slice.call(scope.querySelectorAll('[data-cafx-color-prev]'));
var colorNext = [].slice.call(scope.querySelectorAll('[data-cafx-color-next]'));
if (!panels.length) return null;
/* Brug de faktiske nøgler fra DOM'en i stedet for at antage 0..n-1 */
var keys = panels.map(function(p) { return p.getAttribute('data-cafx-panel'); });
var pos = 0;
function select(nextPos) {
var total = keys.length;
if (!total) return;
pos = ((nextPos % total) + total) % total;
var key = keys[pos];
sw.forEach(function(b) {
var on = b.getAttribute('data-cafx-swatch') === key;
b.classList.toggle('is-active', on);
b.setAttribute('aria-selected', on ? 'true' : 'false');
});
panels.forEach(function(p) {
p.classList.toggle('is-active', p.getAttribute('data-cafx-panel') === key);
});
}
colorPrev.forEach(function(btn) {
btn.addEventListener('click', function() { select(pos - 1); });
});
colorNext.forEach(function(btn) {
btn.addEventListener('click', function() { select(pos + 1); });
});
sw.forEach(function(b) {
b.addEventListener('click', function() {
select(keys.indexOf(b.getAttribute('data-cafx-swatch')));
});
b.addEventListener('keydown', function(e) {
var i = sw.indexOf(b);
var t;
if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
e.preventDefault();
t = sw[(i + 1) % sw.length];
} else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
e.preventDefault();
t = sw[(i - 1 + sw.length) % sw.length];
}
if (t) {
t.focus();
select(keys.indexOf(t.getAttribute('data-cafx-swatch')));
}
});
});
select(0);

return { select: select };

}


/* ---- fit-styring: bytter produkter i karusel + farvevaelger ---- */

var cafxCarousels = {};
var cafxColorGroups = {};
var cafxCurrentFit = 'oversize';

root.querySelectorAll('[data-cafx-product-carousel]').forEach(function(el) {
cafxCarousels[el.getAttribute('data-cafx-fit-wrap') || 'oversize'] = cafxInitCarousel(el);
});

root.querySelectorAll('[data-cafx-fit-group]').forEach(function(el) {
cafxColorGroups[el.getAttribute('data-cafx-fit-group')] = cafxInitColors(el);
});

function cafxSetFit(fit, silent) {
fit = fit === 'regular' ? 'regular' : 'oversize';
cafxCurrentFit = fit;

['[data-cafx-fit-wrap]', '[data-cafx-fit-group]', '[data-cafx-fit-only]'].forEach(function(sel) {
root.querySelectorAll(sel).forEach(function(el) {
var own = el.getAttribute('data-cafx-fit-wrap') || el.getAttribute('data-cafx-fit-group') || el.getAttribute('data-cafx-fit-only');
el.classList.toggle('cafx-fit-hidden', own !== fit);
});
});

root.querySelectorAll('[data-cafx-fit-btn]').forEach(function(b) {
var on = b.getAttribute('data-cafx-fit-btn') === fit;
b.classList.toggle('is-active', on);
b.setAttribute('aria-selected', on ? 'true' : 'false');
});

var inst = cafxCarousels[fit];
if (inst && inst.refresh) inst.refresh();

if (!silent) {
try {
var url = new URL(window.location.href);
if (fit === 'regular') {
url.searchParams.set('fit', 'regular');
} else {
url.searchParams.delete('fit');
}
history.replaceState(null, '', url.toString());
} catch (e) {}
}
}

[].slice.call(root.querySelectorAll('[data-cafx-fit-btn]')).forEach(function(b) {
b.addEventListener('click', function() {
cafxSetFit(b.getAttribute('data-cafx-fit-btn'), false);
});
b.addEventListener('keydown', function(e) {
if (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
e.preventDefault();
var other = cafxCurrentFit === 'regular' ? 'oversize' : 'regular';
cafxSetFit(other, false);
var target = root.querySelector('[data-cafx-fit-btn="' + other + '"]');
if (target) target.focus();
}
});
});

(function() {
var start = 'oversize';
try {
var q = new URL(window.location.href).searchParams.get('fit');
if (q && q.toLowerCase().indexOf('reg') === 0) start = 'regular';
} catch (e) {}
cafxSetFit(start, true);
})();

function cartBase() {
return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
}
function fetchJSON(url, opts) {
return fetch(url, opts).then(function(res) {
return res.json().then(function(data) {
if (!res.ok) throw data;
return data;
});
});
}
function themeCartEls() {
return ['page-header', 'cart-drawer'].map(function(sel) {
return document.querySelector(sel);
}).filter(function(el) {
return el && el.dataset && el.dataset.sectionId && typeof el.updateFromCartChange === 'function';
});
}
function themeCartIds() {
var ids = themeCartEls().map(function(el) {
return el.dataset.sectionId;
}).filter(Boolean);
['cart-drawer', 'cart-icon-bubble'].forEach(function(id) {
if (ids.indexOf(id) < 0) ids.push(id);
});
return ids;
}
function updateCartBubble(cart) {
var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
if (count === null) return;
document.querySelectorAll('.cart-count-bubble,.cart-link__count,[data-cart-count],.header-cart__count,.js-cart-count').forEach(function(el) {
el.textContent = count;
el.classList.toggle('hidden', count < 1);
el.classList.toggle('visually-hidden', count < 1);
});
}
function fireThemeCartEvents(addResponse, cart) {
[
'cart:refresh',
'cart:updated',
'cart:update',
'theme:cart:change',
'theme:cart:update',
'cc:cart:updated',
'on:cart:change',
'dispatch:cart-drawer:refresh'
].forEach(function(name) {
document.dispatchEvent(new CustomEvent(name, {
bubbles: true,
detail: {
cart: cart,
item: addResponse
}
}));
document.documentElement.dispatchEvent(new CustomEvent(name, {
bubbles: true,
detail: {
cart: cart,
item: addResponse
}
}));
});
try {
if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
source: 'comfort-airflex',
cartData: cart,
productVariantId: addResponse && addResponse.variant_id
});
}
} catch (e) {}
}
function applyThemeSections(sections) {
var did = false;
if (!sections) return did;
themeCartEls().forEach(function(el) {
var html = sections[el.dataset.sectionId];
if (html) {
try {
el.updateFromCartChange(html);
did = true;
} catch (e) {}
}
});
return did;
}
function fallbackRefreshCartDrawer() {
var drawer = document.querySelector('cart-drawer');
var form = drawer ? drawer.querySelector('cart-form') : document.querySelector('cart-form');
var id = (drawer && drawer.dataset && drawer.dataset.sectionId) || (form && form.dataset && form.dataset.sectionId) || 'cart-drawer';
return fetch(cartBase() + '?section_id=' + encodeURIComponent(id), {
headers: {
Accept: 'text/html',
'X-Requested-With': 'XMLHttpRequest'
}
}).then(function(r) {
return r.ok ? r.text() : '';
}).then(function(html) {
if (!html) return false;
try {
if (drawer && typeof drawer.updateFromCartChange === 'function') {
drawer.updateFromCartChange(html);
return true;
}
if (form && typeof form.refreshFromHtml === 'function') {
form.refreshFromHtml(html);
return true;
}
} catch (e) {}
return false;
}).catch(function() {
return false;
});
}
function refreshCartBeforeOpen(addResponse, cart) {
updateCartBubble(cart);
var did = applyThemeSections(addResponse && addResponse.sections);
var p = did ? Promise.resolve(true) : fallbackRefreshCartDrawer();
return p.then(function() {
updateCartBubble(cart);
fireThemeCartEvents(addResponse, cart);
document.dispatchEvent(new CustomEvent('on:cart:add', {
bubbles: true,
detail: {
variantId: addResponse && addResponse.variant_id,
cart: cart
}
}));
return cart;
});
}
function afterPaint() {
return new Promise(function(res) {
requestAnimationFrame(function() {
requestAnimationFrame(res);
});
});
}
function openCartDrawer(opener) {
var detail = {
opener: opener || null
};
['dispatch:cart-drawer:open', 'cart-drawer:open'].forEach(function(nm) {
document.dispatchEvent(new CustomEvent(nm, {
bubbles: true,
detail: detail
}));
document.documentElement.dispatchEvent(new CustomEvent(nm, {
bubbles: true,
detail: detail
}));
});
var drawer = document.querySelector('.js-cart-drawer,cart-drawer,#CartDrawer,.cart-drawer,[data-cart-drawer]');
if (drawer) {
try {
if (typeof drawer.open === 'function') {
drawer.open(opener || null);
return true;
}
if (typeof drawer.show === 'function') {
drawer.show(opener || null);
return true;
}
} catch (e) {}
}
var btn = document.querySelector('cart-drawer-opener button,cart-drawer-opener a,[aria-controls="CartDrawer"],[aria-controls="cart-drawer"],.js-cart-drawer-open,.header__icon--cart,.cart-link,[data-cart-drawer-toggle],[data-cart-drawer-open]');
if (btn) {
try {
btn.click();
return true;
} catch (e) {}
}
if (drawer) {
drawer.setAttribute('open', '');
drawer.classList.add('is-open', 'active', 'open', 'drawer--active');
document.documentElement.classList.add('cart-drawer-open');
document.body.classList.add('cart-drawer-open', 'overflow-hidden');
return true;
}
return false;
}
function addForms() {
root.querySelectorAll('[data-cafx-form]').forEach(function(f) {
f.addEventListener('submit', function(e) {
e.preventDefault();
var msg = f.querySelector('.cafx-form-message');
var btn = f.querySelector('.cafx-add-btn');
var fd = new FormData(f);
var ids = themeCartIds();
if (!fd.get('id')) {
if (msg) msg.textContent = 'Kies eerst een maat.';
return;
}
if (ids.length) {
fd.set('sections', ids.join(','));
fd.set('sections_url', window.location.pathname);
}
if (btn) {
btn.classList.add('is-loading');
btn.disabled = true;
btn.textContent = 'Toevoegen aan winkelmandje...';
}
if (msg) msg.textContent = '';
fetchJSON(cartBase() + 'cart/add.js', {
method: 'POST',
headers: {
Accept: 'application/json',
'X-Requested-With': 'XMLHttpRequest'
},
body: fd
}).then(function(addResponse) {
return fetchJSON(cartBase() + 'cart.js', {
method: 'GET',
headers: {
Accept: 'application/json',
'X-Requested-With': 'XMLHttpRequest'
}
}).then(function(cart) {
return refreshCartBeforeOpen(addResponse, cart).then(function() {
return afterPaint().then(function() {
openCartDrawer(btn);
return cart;
});
});
});
}).then(function() {
if (msg) msg.textContent = 'Toegevoegd aan winkelmandje.';
}).catch(function(x) {
if (msg) msg.textContent = (x && x.description) || (x && x.message) || 'Er is iets misgegaan.';
}).finally(function() {
if (btn) {
btn.classList.remove('is-loading');
btn.disabled = false;
btn.textContent = 'In winkelmandje';
}
});
});
});
}
addForms();
})();
